import React from 'react';

export const QRCodeRealSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10" cy="10" r="10" fill="#FFA55B" />
    <g clipPath="url(#clip0_11959_70072)">
      <path
        d="M5 5V8.32031H8.32031V5H5ZM7.53906 7.53906H5.78125V5.78125H7.53906V7.53906Z"
        fill="white"
      />
      <path d="M7.05078 6.26953H6.26953V7.05078H7.05078V6.26953Z" fill="white" />
      <path
        d="M11.6797 5V8.32031H15V5H11.6797ZM14.2188 7.53906H12.4609V5.78125H14.2188V7.53906Z"
        fill="white"
      />
      <path d="M13.7305 6.26953H12.9492V7.05078H13.7305V6.26953Z" fill="white" />
      <path
        d="M5 11.6797V15H8.32031V11.6797H5ZM7.53906 14.2188H5.78125V12.4609H7.53906V14.2188Z"
        fill="white"
      />
      <path d="M7.05078 12.9492H6.26953V13.7305H7.05078V12.9492Z" fill="white" />
      <path d="M6.5625 8.84766H5.78125V9.62891H6.5625V8.84766Z" fill="white" />
      <path
        d="M7.34375 10.4102V9.62891H6.5625V10.4102H7.32422V11.1914H8.10547V10.4102H7.34375Z"
        fill="white"
      />
      <path d="M11.25 6.50391H10.4688V7.28516H11.25V6.50391Z" fill="white" />
      <path d="M9.6875 5.78125H8.90625V7.28516H9.6875V5.78125Z" fill="white" />
      <path d="M10.4688 5H9.6875V5.78125H10.4688V5Z" fill="white" />
      <path
        d="M9.6875 7.28516V8.06641H8.90625V8.84766H10.4688V7.28516H9.6875Z"
        fill="white"
      />
      <path
        d="M10.4688 11.9336V11.1719H9.6875V9.62891H8.90625V11.1914H9.6875V11.9531H10.4688V12.7148H12.0312V11.9336H10.4688Z"
        fill="white"
      />
      <path d="M11.25 8.84766H10.4688V10.4102H11.25V8.84766Z" fill="white" />
      <path
        d="M14.2188 9.60938V8.84766H12.793V9.62891H12.0312V10.4102H12.8125V11.1719H15V9.60938H14.2188ZM14.2188 10.3906H12.8125V9.62891H14.2188V10.3906Z"
        fill="white"
      />
      <path d="M15 11.9336H14.2188V13.4961H15V11.9336Z" fill="white" />
      <path d="M12.0312 10.4102H11.25V11.1914H12.0312V10.4102Z" fill="white" />
      <path d="M12.8125 12.7148H12.0312V13.4961H12.8125V12.7148Z" fill="white" />
      <path d="M13.5938 11.9336H12.8125V12.7148H13.5938V11.9336Z" fill="white" />
      <path
        d="M12.8125 13.4961V15H13.5938V14.2773H14.2188V13.4961H12.8125Z"
        fill="white"
      />
      <path d="M9.6875 11.9531H8.90625V13.4375H9.6875V11.9531Z" fill="white" />
      <path
        d="M11.25 14.2188V13.4375H9.6875V15H10.4688V14.2188H11.2305V15H12.0117V14.2188H11.25Z"
        fill="white"
      />
      <path d="M8.90625 8.84766H7.34375V9.62891H8.90625V8.84766Z" fill="white" />
      <path d="M5.78125 9.62891H5V11.1914H5.78125V9.62891Z" fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_11959_70072">
        <rect width="10" height="10" fill="white" transform="translate(5 5)" />
      </clipPath>
    </defs>
  </svg>
);

export default QRCodeRealSvg;
